// Updated PhotoelectricSensors.jsx with custom class names
import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';

import { FaFilePdf,FaChevronRight,FaEnvelope } from 'react-icons/fa';


import '../styles/PhotoelectricSensors.css';
import PhotoelectricMain from '../assets/photoelectric-main.png'; // replace with actual image path
// import QuoteModal from './QuoteModal'; // Adjust path
import WhatsAppModal from './WhatsAppModal';



import f1 from '../assets/f1.jpg'
import f2 from '../assets/f2.jpg'
import f3 from '../assets/f3.jpg'
import f4 from '../assets/f4.jpg'
import f5 from '../assets/f5.jpg'
import f6 from '../assets/f6.jpg'
import f7 from '../assets/f7.jpg'
import f8 from '../assets/f8.jpg'
import f9 from '../assets/f9.jpg'
import f10 from '../assets/f10.jpg'
import f11 from '../assets/f11.jpg'
import f12 from '../assets/f12.jpg'
import f13 from '../assets/f13.jpg'

import p1 from '../assets/p1.jpg'
import p2 from '../assets/p2.jpg'
import p3 from '../assets/p3.jpg'
import p4 from '../assets/p4.jpg'
import p5 from '../assets/p5.jpg'
import p6 from '../assets/p6.jpg'
import p7 from '../assets/p7.jpg'
import p8 from '../assets/p8.jpg'
import p9 from '../assets/p9.jpg'
import p10 from '../assets/p10.jpg'
import p11 from '../assets/p11.jpg'
import p12 from '../assets/p12.jpg'

import l1 from '../assets/l1.jpg'
import l2 from '../assets/l2.jpg'
import l3 from '../assets/l3.jpg'

import tof1 from '../assets/tof1.webp'
import PhotoelectricSpecsImg from '../assets/PhotoelectricSensorSpecs.jpg'; // adjust filename & path

import Photoelectric_Sensors_Catalog_2024 from '../assets/Photoelectric Sensors Catalog_2024.pdf'

import fiber_optic_sensors_fn from '../assets/Fiber Optic Sensors Catalog.pdf'
import photoelectric_sensors_Fn from '../assets/Photoelectric Sensors Catalog_2024.pdf'
import laser_sensors_Fn from '../assets/Laser Sensors Catalog.pdf'
// import TOF_LONG_DISTANCE_TYPE_PX_FM_SERIES_PHOTOELECTRIC_SENSOR from '../assets/TOF_LONG_DISTANCE_TYPE_PX_FM_SERIES_PHOTOELECTRIC_SENSOR.pdf'
import ELT_M10N_AKU from '../assets/ELT-M10N AKU.pdf'

import Photoelectricsensor_PTEPdf from '../assets/Photo sensor/Photoelectric sensor_PTE.pdf'
import Photoelectric_ELTSeriesPdf from '../assets/Photo sensor/Photoelectric_ELT Series.pdf'
import Photoelectric_ESEseriesPdf from '../assets/Photo sensor/Photoelectric_ESE series.pdf'
import Photoelectric_ESLSeriesPdf from '../assets/Photo sensor/Photoelectric_ESL Series.pdf'
import Photoelectric_MP2SeriesPdf from '../assets/Photo sensor/Photoelectric_MP2 Series.pdf'
import PhotoelectricSensorESBSeriesPdf from '../assets/Photo sensor/Photoelectric Sensor ESB Series.pdf'
import PhotoelectricSensorReflectorPdf from '../assets/Photo sensor/Photoelectric Sensor Reflector.pdf'
import PhotoelectricSensorPM18KSeriesPdf from '../assets/Photo sensor/Photoelectric Sensor PM 18K Series.pdf'



const tabs = ['Fiber Optic Sensors', 'Photoelectric Sensors', 'Laser Sensors', 'TOF Long Distance','Technical Specifications'];

const downloadLinks = {
  'Fiber Optic Sensors': fiber_optic_sensors_fn,
  'Photoelectric Sensors': photoelectric_sensors_Fn,
  'Laser Sensors': laser_sensors_Fn,
  'TOF Long Distance': ELT_M10N_AKU,

  // 'PG1 Dual Digital Display Fiber Optic Amplifier':,
  // 'PE1 Standard Dual Digital Fiber Amplifier':,
  // 'PC1 Ultra High Speed Response Dual Digital Display Fiber Optic Amplifier':,
  // 'Regular Type':,
  // 'Array-type':,
  // 'Flat Bracket Type':,
  // 'Side-view Type':,
  // 'High Elasticity Type':,
  // 'High Temperature Resistant Type':,
  // 'Small Spot Type':,
  // 'Combination Type':,
  // 'High End Type':,
  // 'Lens':,




  // 'Color/Mark Detection(ESC/ESE Series)':,
  // 'Square Type (PTE/PTEW/PTV Series)':,
  // 'Flat Type(MP2 Series)':,
  // 'Thin Type (ESL series)':,
  // 'BGS Type(ESB Series)':,
  // 'Transparent Object Detection (EST Series)':,
  // 'Color/Mark Detection(ESC/ESE Series)':,
  // 'TOF Principle Type (PM18-TF/PX series)':,
  // 'IP69K High Protection Type ( PM18K Series )':,
  // 'Anti-glare Type(PTL Series)':,
  // 'IO-Link Type (PTZ-C Series)':,
  // 'Reflectors':,




  // '':,
  // '':,
  // '':,
  // '':,
};

const data = {
'Fiber Optic Sensors': [
    {
      title: 'PG1 Dual Digital Display Fiber Optic Amplifier',
      features: [
        'With automatic light compensation technology, 4-channel anti-light interference',
        'Small hysteresis, dual output for option, the fastest speed up to 13 μs',
      ],
      img: f1,
      pdf: ELT_M10N_AKU // Example — replace with correct PDF file
    },
    {
      title: 'PE1 Standard Dual Digital Fiber Amplifier',
      features: [
        'Automatic light compensation technology and great adaptability for less maintenance.',
        'Six adjustable response speeds, up to 50us small hysteresis.',
        'High power mode for detecting transparent object and small object',
      ],
      img: f2,
    },
    {
      title: 'PC1 Ultra High Speed Response Dual Digital Display Fiber Optic Amplifier',
      features: [
        'Fastest response time in the industry (15ms)',
        'Digital display of red and green lights for comparison, easy to set up',
        'Unique technology for light compensation.',
      ],
      img: f3,
    },
    {
      title: 'Regular Type',
      features: [
        'Imported fiber optic core, wonderful performance',
        'Long sensing distance, cost-effective',
      ],
      img: f4,
    },
    {
      title: 'Array-type',
      features: [
        'Solution for missing object detection',
        'To detect unclear position objects',
      ],
      img: f5,
    },
    {
      title: 'Flat Bracket Type',
      features: [
        'Flexible installation, easy to fix',
        'Suitable for limited space',
      ],
      img: f6,
    },
    {
      title: 'Side-view Type',
      features: [
        'Easy access to detected objects with high precision',
      ],
      img: f7,
    },
    {
      title: 'High Elasticity Type',
      features: [
        'Good performance with excellent flexibility',
        'After bending at angles of 90 degree, transmission ability only reduces 10%',
      ],
      img: f8,
    },
    {
      title: 'High Temperature Resistant Type',
      features: [
        'Classical cylindrical appearance, high stability',
        'Withstand temperatures up to 350 C',
      ],
      img: f9,
    },
    {
      title: 'Small Spot Type',
      features: [
        'Built-in lens, small beam spot',
        'Customizable high-flex optical fiber cables',
      ],
      img: f10,
    },
    {
      title: 'Combination Type',
      features: [
        'Several fiber units combined together',
        'Customizable fiber length to tail your needs',
      ],
      img: f11,
    },
    {
      title: 'High End Type',
      features: [
        'Pioneering hot melt leveling technology',
        'Metal protective cap design',
      ],
      img: f12,
    },
    {
      title: 'Lens',
      features: [
        'Offering a full range specifications that can replace most of the popular products in the market',
        'Thru-beam and diffuse reflection types are optional.',
      ],
      img: f13,
    },
  ],
  'Photoelectric Sensors': [
    {
      title: 'Color/Mark Detection(ESC/ESE Series)',
      features: [
        'Epoxy resin fillings ,powerful in shock resistance',
        'The smallest diameter(8mm) in the industry',
        'Nikel plated brass, effectively resist industrial interference',
      ],
      img: p1,

    },
    {
      title: 'Square Type (PTE/PTEW/PTV Series)',
      features: [
        'Traditional square housing with great performance',
        '25.4mm standard hole pitch for simple installation',
        'Identifying the action clearly with dual LED indicators',
      ],
      img: p2,
      pdf: Photoelectricsensor_PTEPdf      
    },
    {
      title: 'Flat Type(MP2 Series)',
      features: [
        'Sensing surfaces on top side and front side support various detections',
        'Can switch Lon and Don switch flexibly',
        'Long distance detection up to 40mm(white cardboard)',
      ],
      img: p3,
      pdf:Photoelectric_MP2SeriesPdf
    },
    {
      title: 'Thin Type (ESL series)',
      features: [
        '3.5mm ultra—thin design, greatly saves installation space',
        'ip67 Protection degree, excellent mechanical performance',
        'LED indicator is bright and can be clearly seen from the back',
      ],
      img: p4,
      pdf:Photoelectric_ESLSeriesPdf
    },
    {
      title: 'BGS Type(ESB Series)',
      features: [
        'Free from objects and background colors with stable detection',
        'Built-in rotational knobs, with many turns for fine—turning of sensitivity adjustment',
        'IP67 protection degree, with excellent performance in harsh environments',
      ],
      img: p5,
      pdf:PhotoelectricSensorESBSeriesPdf
    },
    {
      title: 'Transparent Object Detection (EST Series)',
      features: [
        'No blind spot (detection for every corner)',
        'Suitable for moving objects',
        'Best options for different kinds of glass or plastics',
      ],
      img: p6,
    },
    {
      title: 'Color/Mark Detection(ESC/ESE Series)',
      features: [
        'Built-in RGB light sources',
        'Automatic adjustment to the most suitable light source according to the detected color',
        'Two detection modes, mark and color',
      ],
      img: p7,
      pdf:Photoelectric_ESEseriesPdf
    },
    {
      title: 'TOF Principle Type (PM18-TF/PX series)',
      features: [
        'Upto 3 meters range',
        'TOF principle, high stability',
        'Independent of object color, background color and reflectivity',
      ],
      img: p8,
    },
    {
      title: 'IP69K High Protection Type ( PM18K Series )',
      features: [
        'AISI 316L stainless steel housing material',
        'Protection grade IP69K, excellent mechanical performance',
        'Applied in harsh environments.',
      ],
      img: p9,
      pdf:PhotoelectricSensorPM18KSeriesPdf
    },
    {
      title: 'Anti-glare Type(PTL Series)',
      features: [
        'Not interfered byglare, with stable detection',
        'Built-in multi—turn potentiometer for fine adjustment of sensitivity',
        'IP67 excellent mechanical performance',
      ],
      img: p10,
    },
    {
      title: 'IO-Link Type (PTZ-C Series)',
      features: [
        'With IO function, contributing to industrial 4.0',
        'Identify the action clearly with dual LED indicators',
        'IP67 excellent mechanical performance',
      ],
      img: p11,
    },
    {
      title: 'Reflectors',
      features: [
        'Made of special material (robust housing)',
        'Shapes as circular, square and combination etc',
        'Customization is available as requested by clients',
      ],
      img: p12,
      pdf:PhotoelectricSensorReflectorPdf
    },
  ],
  'Laser Sensors': [
    {
      title: 'Square Type (ELB/ELC/ELE Series)',
      features: [
        'Response time high up to 0.25ms, suitable for detecting fast moving objects',
        'Light spot diameter for thru—beam products is just 30mm(at 30m)',
        'Protection degree IP67',
      ],
      img: l1,
    },
    {
      title: 'BGS Type (ELS/ELT Series)',
      features: [
        'Free from the interference of objects and background colors, with stable detection',
        'Laser source, suitable for long distance detection of small objects',
        'Built-in rotational knobs with multiple turns to realize slight sensitivity adjustment',
      ],
      img: l2,
    },
    {
      title: 'Transparent Objects Detection (ESQ Series)',
      features: [
        'Automatically adjust threshold value according to the amount of lights',
        'Laser sources, suitable for detections of different glass or PET bottles',
        'Customization is available as requested by clients',
      ],
      img: l3,
    },
  ],
  'TOF Long Distance': [
    {
      title: 'D-TOF Principle Type ELT-M3BP Series',
      features: [
        'Detection Range：0.05-1m @5% reflectance; 0.05-10m @30% reflectance',
        'Output Mode：PNP/NPN, 4-20 mA, 0-10v, RS 485, Instant/delayed response mode, the switch mode is the length of the key',
        'Repeatability：±5mm',
        'Response Time ：1ms',
        'Light Source：Laser diode 650nm, Class 2',
      ],
      img: tof1,
    }
  ]
};

export default function PhotoelectricSensors() {
  const [activeTab, setActiveTab] = useState('Fiber Optic Sensors');
  // const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);


  return (
    <div className="photoelectric-wrapper">
      <Header />

      <div className="hero-banner15">
        <div className="hero-banner15-content">
          <h1>PHOTOELECTRIC SENSORS</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>Photoelectric Sensors</span>
          </div>
        </div>
      </div>

      <div className="sensor-intro-wrap">
        <img src={PhotoelectricMain} alt="Photoelectric Sensor" />
        <div className="sensor-description">
          <h2>Photoelectric Sensor</h2>
          <ul>
            <li>Available in a variety of models, like thin type, square type, cylindrical type, transparent object detection type, background suppression type, etc.</li>
            <li>L.on and D.on switch freely.</li>
            <li>Solid and durable metal housing; Economical plastic housing and easy to install.</li>
            <li>Short circuit protection and reverse polarity protection.</li>
            <li>Switch frequency up to 5000Hz.</li>
          </ul>
          <div className="sensor-buttons">
             <a href={Photoelectric_Sensors_Catalog_2024} target="_blank" rel="noopener noreferrer">
             <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Full Catalog Download</button>            
             </a>
          <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
          {/* <QuoteModal isOpen={showModal} onClose={() => setShowModal(false)} /> */}
                {/* WhatsApp Modal */}
      <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

          </div>
        </div>
      </div>

      <div className="sensor-tabs">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={activeTab === tab ? 'active' : ''}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

<div className="sensor-product-section">
  {activeTab === 'Technical Specifications' ? (
    <div className="Photoelectricspecs-image-wrapper">
      <img
        src={PhotoelectricSpecsImg}
        alt="Photoelectric Sensor Technical Specs"
        className="Photoelectricspecs-img"
      />
    </div>
  ) : (
    <>
      {data[activeTab]?.length > 0 ? (
        <div className="sensor-product-grid">
  {data[activeTab].map((product, index) => (
    <div className="photoelectric-product-card" key={index}>
      <img src={product.img} alt={product.title} />
      <h4>{product.title}</h4>
      <ul>
        {product.features.map((f, idx) => (
          <li key={idx}>{f}</li>
        ))}
      </ul>
      {product.pdf && (
  <a href={product.pdf} target="_blank" rel="noopener noreferrer">
    <button className="download-catalog-btn">
      <FaFilePdf style={{ marginRight: '6px', color: 'red' }} />
      Download
    </button>
  </a>
)}

    </div>
  ))}
</div>

      ) : (
        <p style={{ textAlign: 'center', padding: '20px' }}>No products available.</p>
      )}
      <br />
      <a href={downloadLinks[activeTab]} target="_blank" rel="noopener noreferrer">
        <button className="download-catalog-btn">
          <FaFilePdf style={{ marginRight: '8px' }} /> Download
        </button>
      </a>
    </>
  )}
</div>
      
      <Footer />
    </div>
  );
}